import { papeisVisualizarRamos } from '@/services/ramosAtividadeService'
import Vue from 'vue'
import $ from 'jquery'
import store from '@/store'
import VueRouter from 'vue-router'
import { saveLastAppRoute } from '@/utils/routeSession'

import Afiliados from '@/views/convenios/Afiliados.vue'
import RelatoriosConvenio from '@/views/convenios/RelatoriosConvenio.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
   return originalPush.call(this, location).catch(err => {
      if (VueRouter.isNavigationFailure ? VueRouter.isNavigationFailure(err, 16) : (err && err.name === 'NavigationDuplicated')) {
         return err
      }
      return Promise.reject(err)
   })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
   if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
   return originalReplace.call(this, location).catch(err => {
      if (VueRouter.isNavigationFailure ? VueRouter.isNavigationFailure(err, 16) : (err && err.name === 'NavigationDuplicated')) {
         return err
      }
      return Promise.reject(err)
   })
}

const routes = [
   { path: '/pessoas/ramos-atividade', name: 'RamosAtividade', component: () => import('../views/pessoas/RamosAtividade.vue'), meta: { icon: 'bx bx-category', role: papeisVisualizarRamos } },
	{ path: '/convenios/afiliados', name: 'Afiliados', component: Afiliados },
	{ path: '/convenios/relatorios', name: 'RelatoriosConvenio', component: RelatoriosConvenio },
	{ path: '/relatorios/dinamico', name: 'RelatorioDinamico', component: () => import('../views/relatorios/RelatorioDinamico.vue'), meta: { icon: 'bx bx-customize' } },
   {
      path: '/selecaoEmpresa',
      name: 'Seleção de Empresa',
      component: () => import('../views/SelecaoEmpresa.vue'),
      meta: { 'icon': 'bx bx-building' }
   },
   {
      path: '/gerencial',
      name: 'Gerencial',
      component: () => import('../views/Gerencial.vue'),
      meta: { 'icon': 'bx bx-cog' }
   },
   {
      path: '/paginaInicial',
      name: 'Página_inicial',
      component: () => import('../views/PaginaInicial.vue'),
      meta: { 'icon': 'bx bx-home-circle' }
   },
   {
      path: '/conversas',
      name: 'Conversas',
      component: () => import('../views/Conversas.vue'),
      meta: { 'icon': 'bx bx-message-dots', role: 'USER_DASHBOARD' }
   },
   {
      path: '/tutoriais',
      name: 'Tutoriais',
      component: () => import('../views/Tutoriais.vue'),
      meta: { 'icon': 'bx bx-play-circle' }
   },
   {
      path: '/dashboard',
      name: 'Dashboard',
      redirect: '/paginaInicial',
      meta: { 'icon': 'bx bx-bar-chart-alt-2' }
   },
   {
      path: '/perfil',
      name: 'Perfil',
      component: () => import('../views/perfil/Perfil.vue'),
      meta: { 'icon': 'bx bx-user' }
   },
   {
      path: '/usuarios',
      name: 'Usuarios',
      component: () => import('../views/usuarios/Usuarios.vue'),
      meta: { 'icon': 'bx bx-user', role: 'USUARIO_VIEW' }
   },
   {
      path: '/empresas',
      name: 'Empresas',
      component: () => import('../views/empresas/Empresas.vue'),
      meta: { 'icon': 'bx bx-building', role: 'EMPRESA_VIEW' }
   },
   {
      path: '/Clientes',
      name: 'Clientes',
      component: () => import('../views/pessoas/Clientes.vue'),
      meta: { 'icon': 'bx bx-id-card', role: 'CLIENTE_VIEW' }
   },
   {
      path: '/Fornecedores',
      name: 'Fornecedores',
      component: () => import('../views/pessoas/Fornecedores.vue'),
      meta: { 'icon': 'bx bx-package', role: 'FORNECEDOR_VIEW' }
   },
   {
      path: '/Vendedores',
      name: 'Vendedores',
      component: () => import('../views/pessoas/Vendedores.vue'),
      meta: { 'icon': 'bx bx-user', role: 'VENDEDOR_VIEW' }
   },
   {
      path: '/Tecnicos',
      name: 'Tecnicos',
      component: () => import('../views/pessoas/Tecnicos.vue'),
      meta: { 'icon': 'bx bx-wrench', role: 'TECNICO_VIEW' }
   },
   {
      path: '/Colaboradores',
      name: 'Colaboradores',
      component: () => import('../views/pessoas/Colaboradores.vue'),
      meta: { 'icon': 'bx bx-user-circle', role: 'COLABORADOR_VIEW' }
   },
   {
      path: '/Transportadores',
      name: 'Transportadores',
      component: () => import('../views/pessoas/Transportadores.vue'),
      meta: { 'icon': 'bx bx-truck', role: 'TRANSPORTADOR_VIEW' }
   },
   {
      path: '/frotas', name: 'Frotas', component: () => import('../views/frotas/Frotas.vue'), meta: { role: 'PRODUTO_VIEW', icon: 'bx bx-trip' }
   },
   {
      path: '/produtos',
      name: 'Produtos',
      component: () => import('../views/produtos/Produtos.vue'),
      meta: { 'icon': 'bx bx-package', role: 'PRODUTO_VIEW' }
   },
   {
      path: '/produtos/variacoes', name: 'Variacoes', component: () => import('../views/produtos/Variacoes.vue'), meta: { role: 'PRODUTO_VIEW', icon: 'bx bx-layer' }
   },
   {
      path: '/produtos/cargas-balanca', name: 'CargasBalanca', component: () => import('../views/produtos/CargasBalanca.vue'), meta: { role: 'PRODUTO_VIEW', icon: 'bx bx-package' }
    },
    {
      path: '/produtos/tabelas-preco',
      name: 'ProdutosTabelasPreco',
      component: () => import('../views/produtos/TabelasPreco.vue'),
      meta: { 'icon': 'bx bx-table' , role: 'TABELA_PRECO_VIEW'}
   },
   {
      path: '/produtos/tributacao',
      name: 'ProdutosTributacao',
      component: () => import('../views/financeiro/configuracoes/Tributacao.vue'),
      meta: { 'icon': 'bx bx-calculator', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/grupos',
      name: 'Grupos',
      component: () => import('../views/produtos/Grupos.vue'),
      meta: { 'icon': 'bx bx-package', role: 'GRUPO_VIEW' }
   },
   {
      path: '/marcas',
      name: 'Marcas',
      component: () => import('../views/produtos/Marcas.vue'),
      meta: { 'icon': 'bx bx-package', role: 'MARCA_VIEW' }
   },
   {
      path: '/unidadesMedida',
      name: 'UnidadeMedida',
      component: () => import('../views/produtos/UnidadesMedida.vue'),
      meta: { 'icon': 'bx bx-package', role: 'UNIDADE_MEDIDA_VIEW' }
   },
   {
      path: '/setores',
      name: 'Setores',
      component: () => import('../views/produtos/Setores.vue'),
      meta: { 'icon': 'bx bx-package' , role: 'SETOR_VIEW'}
   },
   {
      path: '/produtos/locais-estoque',
      name: 'LocaisEstoque',
      component: () => import('../views/produtos/LocaisEstoque.vue'),
      meta: { 'icon': 'bx bx-map-pin' , role: 'ESTOQUE_VIEW'}
   },
   {
      path: '/servicos',
      name: 'Servicos',
      component: () => import('../views/servicos/Servicos.vue'),
      meta: { 'icon': 'bx bx-package', role: 'SERVICO_VIEW' }
   },
   {
      path: '/servicos/tipos-os',
      name: 'TiposOS',
      component: () => import('../views/servicos/TiposOS.vue'),
      meta: { 'icon': 'bx bx-category-alt', role: 'SERVICO_VIEW' }
   },
   {
      path: '/servicos/equipamentos',
      name: 'Equipamentos',
      component: () => import('../views/servicos/Equipamentos.vue'),
      meta: { 'icon': 'bx bx-devices', role: 'SERVICO_VIEW' }
   },
   {
      path: '/vendas',
      name: 'Vendas',
      component: () => import('../views/vendas/Vendas.vue'),
      meta: { 'icon': 'bx bx-cart' , role: 'PDV_VIEW'}
   },
   {
      path: '/comercial/orcamento',
      name: 'ComercialOrcamento',
      component: () => import('../views/comercial/Orcamento.vue'),
      meta: { 'icon': 'bx bx-receipt' , role: 'SALES_QUOTE_CREATE'}
   },
   {
      path: '/comercial/ordem-servico',
      name: 'ComercialOrdemServico',
      component: () => import('../views/comercial/OrdemServico.vue'),
      meta: { 'icon': 'bx bx-wrench' , role: 'SERVICE_ORDER_VIEW'}
   },
   {
      path: '/operacional/ordem-servico',
      name: 'OperacionalOrdemServico',
      component: () => import('../views/operacional/OrdemServico.vue'),
      meta: { 'icon': 'bx bx-wrench' , role: 'SERVICE_ORDER_EXECUTE'}
   },
   {
      path: '/operacional/checklist-modelos',
      name: 'ChecklistModelos',
      component: () => import('../views/operacional/ChecklistModelo.vue'),
      meta: { 'icon': 'bx bx-list-check' , role: ['SERVICO_VIEW', 'SERVICE_ORDER_EXECUTE']}
   },
   {
      path: '/comercial/pedido',
      name: 'ComercialPedido',
      component: () => import('../views/comercial/Pedido.vue'),
      meta: { 'icon': 'bx bx-cart' , role: 'SALES_ORDER_VIEW'}
   },
	{
		path: '/cadastros/comercial/promocoes',
		name: 'ComercialPromocoes',
		component: () => import('../views/comercial/Promocoes.vue'),
		meta: { icon: 'bx bx-purchase-tag', role: 'PRODUTO_VIEW' }
	},
	{
		path: '/comercial/devolucoes',
		name: 'ComercialDevolucoesVendas',
		component: () => import('../views/comercial/DevolucoesVendas.vue'),
		meta: { icon: 'bx bx-undo', role: 'SALES_ORDER_VIEW' }
	},
   {
      path: '/comercial/condicional',
      name: 'ComercialCondicional',
      component: () => import('../views/comercial/Condicional.vue'),
      meta: { 'icon': 'bx bx-transfer-alt' , role: 'SALES_ORDER_VIEW'}
   },
   {
      path: '/comercial/veiculos',
      name: 'ComercialVeiculos',
      redirect: '/servicos/equipamentos',
      meta: { 'icon': 'bx bx-devices' , role: 'SERVICO_VIEW'}
   },
   {
      path: '/estoque/gondola',
      name: 'EstoqueControleGondola',
      redirect: '/estoque/ajuste',
      meta: { 'icon': 'bx bx-barcode-reader' , role: 'STOCK_MOVEMENT'}
   },
   {
      path: '/estoque/entrada-manual',
      name: 'EstoqueEntradaManual',
      redirect: '/estoque/ajuste',
      meta: { 'icon': 'bx bx-plus-circle' , role: 'STOCK_MOVEMENT'}
   },
   {
      path: '/estoque/kardex',
      name: 'EstoqueKardex',
      redirect: '/relatorios/estoque-kardex',
      meta: { 'icon': 'bx bx-spreadsheet' , role: 'STOCK_REPORTS'}
   },
   {
      path: '/estoque/ajustes',
      name: 'EstoqueAjustes',
      redirect: '/estoque/ajuste',
      meta: { 'icon': 'bx bx-edit' , role: 'STOCK_MOVEMENT'}
   },
   {
      path: '/estoque/ajuste',
      name: 'EstoqueAjuste',
      component: () => import('../views/estoque/AjustesEstoque.vue'),
      meta: { 'icon': 'bx bx-edit' , role: 'STOCK_MOVEMENT'}
   },
   {
      path: '/estoque/pendencias',
      name: 'EstoquePendencias',
      component: () => import('../views/estoque/PendenciasEstoque.vue'),
      meta: { 'icon': 'bx bx-error-circle' , role: 'STOCK_MOVEMENT'}
   },
   {
      path: '/estoque/pedidos-compra',
      name: 'EstoquePedidosCompra',
      component: () => import('../views/estoque/PedidosCompra.vue'),
      meta: { 'icon': 'bx bx-cart' , role: 'PURCHASE_ORDER_VIEW'}
   },
   {
      path: '/estoque/transferencias',
      name: 'EstoqueTransferencias',
      component: () => import('../views/estoque/TransferenciasEstoque.vue'),
      meta: { 'icon': 'bx bx-transfer-alt' , role: 'STOCK_MOVEMENT'}
   },
   {
      path: '/estoque/nfe-entrada',
      name: 'EstoqueNfeEntrada',
      redirect: '/estoque/entradas-mercadoria',
      meta: { 'icon': 'bx bx-file' , role: 'STOCK_MOVEMENT'}
   },
   {
      path: '/estoque/entradas-mercadoria',
      name: 'EstoqueEntradasMercadoria',
      component: () => import('../views/estoque/EntradasMercadoria.vue'),
      meta: { 'icon': 'bx bx-package' , role: 'STOCK_MOVEMENT'}
   },

   { path: '/estoque/devolucoes-compra', name: 'EstoqueDevolucoesCompra', component: () => import('../views/estoque/DevolucoesCompras.vue'), meta: { icon: 'bx bx-undo', role: 'STOCK_MOVEMENT' } },
   {
      path: '/portal/orcamento/:token',
      name: 'PortalOrcamento',
      component: () => import('../views/portal/OrcamentoPortal.vue'),
      meta: { 'public': true }
   },
   {
      path: '/portal/pedido-compra/:token',
      name: 'PortalPedidoCompra',
      component: () => import('../views/portal/PedidoCompraPortal.vue'),
      meta: { 'public': true }
   },
   {
      path: '/planoContas',
      name: 'PlanoContas',
      component: () => import('../views/financeiro/cadastros/PlanoContas.vue'),
      meta: { 'icon': 'bx bx-spreadsheet', role: 'PLANO_CONTA_VIEW' }
   },
   {
      path: '/centroCustos',
      name: 'CentroCustos',
      component: () => import('../views/financeiro/cadastros/CentroCustos.vue'),
      meta: { 'icon': 'bx bx-detail', role: 'CENTRO_CUSTO_VIEW' }
   },
   {
      path: '/contasOperacionais',
      name: 'ContasOperacionais',
      component: () => import('../views/financeiro/cadastros/ContasOperacionais.vue'),
      meta: { 'icon': 'bx bx-wallet', role: 'CONTA_OPERACIONAL_VIEW' }
   },
   {
      path: '/formasPagamento',
      name: 'FormasPagamento',
      component: () => import('../views/financeiro/cadastros/FormasPagamento.vue'),
      meta: { 'icon': 'bx bx-credit-card', role: 'FORMA_PAGAMENTO_VIEW' }
   },
   {
      path: '/administradorasCartao',
      name: 'AdministradorasCartao',
      component: () => import('../views/financeiro/cadastros/AdministradorasCartao.vue'),
      meta: { 'icon': 'bx bx-credit-card-front', role: 'FORMA_PAGAMENTO_VIEW' }
   },
    {
      path: '/condicoesPagamento',
      name: 'CondicoesPagamento',
      component: () => import('../views/financeiro/cadastros/CondicoesPagamento.vue'),
      meta: { 'icon': 'bx bx-calendar-check', role: 'CONDICAO_PAGAMENTO_VIEW' }
   },
   {
      path: '/contasAPagar',
      name: 'ContasAPagar',
      component: () => import('../views/financeiro/operacional/ContasAPagar.vue'),
      meta: { 'icon': 'bx bx-transfer-alt' , role: 'ACCOUNTS_PAYABLE'}
   },
   {
      path: '/contasAReceber',
      name: 'ContasAReceber',
      component: () => import('../views/financeiro/operacional/ContasAReceber.vue'),
      meta: { 'icon': 'bx bx-money-withdraw' , role: 'ACCOUNTS_RECEIVABLE'}
   },
   {
      path: '/financeiro/borderos-cartao',
      name: 'FinanceiroBorderosCartao',
      component: () => import('../views/financeiro/operacional/BorderosCartao.vue'),
      meta: { 'icon': 'bx bx-credit-card-front', role: 'ACCOUNTS_RECEIVABLE' }
   },
   {
      path: '/financeiro/saldo-contas',
      name: 'SaldoContas',
      component: () => import('../views/financeiro/operacional/CaixaMovimentosManuais.vue'),
      meta: { 'icon': 'bx bx-transfer' , role: 'FINANCIAL_TRANSACTION_VIEW'}
   },
   {
      path: '/financeiro/fechamentos-caixa',
      name: 'FechamentosCaixa',
      component: () => import('../views/financeiro/operacional/CaixaExtrato.vue'),
      meta: { 'icon': 'bx bx-spreadsheet' , role: 'FINANCIAL_TRANSACTION_VIEW'}
   },
   {
      path: '/relatorios/fluxo-caixa',
      name: 'RelatoriosFluxoCaixa',
      component: () => import('../views/financeiro/operacional/CaixaFluxo.vue'),
      meta: { 'icon': 'bx bx-line-chart' , role: 'CASH_FLOW_VIEW'}
   },
   {
      path: '/caixa/movimentos-manuais',
      redirect: '/financeiro/saldo-contas'
   },
   {
      path: '/caixa/extrato',
      redirect: '/financeiro/fechamentos-caixa'
   },
   {
      path: '/caixa/fluxo',
      redirect: '/relatorios/fluxo-caixa'
   },
   {
      path: '/financeiro/conciliacao',
      redirect: '/financeiro/saldo-contas'
   },
   {
      path: '/pdv/caixa',
      name: 'PdvCaixa',
      component: () => import('../views/financeiro/operacional/PdvCaixa.vue'),
      meta: { 'icon': 'bx bx-wallet' , role: 'PDV_VIEW'}
   },
   {
      path: '/pdv/gerenciar-caixas',
      name: 'PdvGerenciarCaixas',
      redirect: '/cadastros/comercial/pontos-venda',
      meta: { 'icon': 'bx bx-store' , role: 'PDV_VIEW'}
   },
   {
      path: '/cadastros/pontos-venda',
      redirect: '/cadastros/comercial/pontos-venda'
   },
   {
      path: '/cadastros/comercial/pontos-venda',
      name: 'PontosVendaCadastros',
      component: () => import('../views/pdv/CadastrosPdv.vue'),
      meta: { 'icon': 'bx bx-store' , role: 'PDV_VIEW', cadastroAba: 'pdvs' }
   },
   {
      path: '/cadastros/comercial/turnos',
      name: 'TurnosComercialCadastros',
      component: () => import('../views/pdv/CadastrosPdv.vue'),
      meta: { 'icon': 'bx bx-time-five' , role: 'PDV_VIEW', cadastroAba: 'turnos' }
   },
   {
      path: '/cadastros/comercial/feriados',
      name: 'FeriadosComercialCadastros',
      component: () => import('../views/pdv/CadastrosPdv.vue'),
      meta: { 'icon': 'bx bx-calendar-star' , role: 'PDV_VIEW', cadastroAba: 'feriados' }
   },
   {
      path: '/pdv/supervisor',
      name: 'PdvSupervisor',
      component: () => import('../views/pdv/Supervisor.vue'),
      meta: { 'icon': 'bx bx-shield-quarter' , role: 'PDV_VIEW'}
   },
   {
      path: '/pdv',
      name: 'Pdv',
      component: () => import('../views/pdv/Pdv.vue'),
      meta: { 'icon': 'bx bx-store' , role: 'PDV_VIEW'}
   },
   {
      path: '/fiscal/venda',
      name: 'FiscalVenda',
      component: () => import('../views/fiscal/EmissaoFiscal.vue'),
      meta: { 'icon': 'bx bx-cart' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/servico',
      name: 'FiscalServico',
      component: () => import('../views/fiscal/EmissaoFiscal.vue'),
      meta: { 'icon': 'bx bx-wrench' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/cte',
      name: 'FiscalCte',
      component: () => import('../views/fiscal/EmissaoFiscal.vue'),
      meta: { 'icon': 'bx bx-file-blank' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/mdfe',
      name: 'FiscalMdfe',
      component: () => import('../views/fiscal/EmissaoFiscal.vue'),
      meta: { 'icon': 'bx bx-trip' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/ciot',
      name: 'FiscalCiot',
      component: () => import('../views/fiscal/EmissaoFiscal.vue'),
      meta: { 'icon': 'bx bx-id-card' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/manifestacao-destinatario',
      name: 'FiscalManifestacaoDestinatario',
      component: () => import('../views/fiscal/ManifestacaoDestinatario.vue'),
      meta: { 'icon': 'bx bx-inbox' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/transporte',
      name: 'FiscalTransporteLegado',
      redirect: '/fiscal/cte',
      meta: { 'icon': 'bx bx-truck' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/documentos',
      name: 'FiscalDocumentos',
      redirect: '/fiscal/venda',
      meta: { 'icon': 'bx bx-file' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/arquivos/xml',
      name: 'FiscalArquivosXml',
      component: () => import('../views/fiscal/ArquivosContabeis.vue'),
      meta: { 'icon': 'bx bx-export' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/arquivos/sped',
      name: 'FiscalArquivosSped',
      component: () => import('../views/fiscal/ArquivosContabeis.vue'),
      meta: { 'icon': 'bx bx-spreadsheet' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/fiscal/arquivos/faturamento',
      name: 'FiscalArquivosFaturamento',
      component: () => import('../views/fiscal/ArquivosContabeis.vue'),
      meta: { 'icon': 'bx bx-receipt' , role: 'FISCAL_VIEW'}
   },
   {
      path: '/relatorios/comissoes',
      name: 'RelatoriosComissoes',
      component: () => import('../views/relatorios/Comissoes.vue'),
      meta: { 'icon': 'bx bx-line-chart' , role: 'SALES_REPORTS'}
   },
   {
      path: '/relatorios/estoque-posicao',
      name: 'RelatoriosEstoquePosicao',
      component: () => import('../views/relatorios/EstoquePosicao.vue'),
      meta: { 'icon': 'bx bx-box' , role: 'STOCK_REPORTS'}
   },
   {
      path: '/relatorios/estoque-kardex',
      name: 'RelatoriosEstoqueKardex',
      component: () => import('../views/estoque/Kardex.vue'),
      meta: { 'icon': 'bx bx-spreadsheet' , role: 'STOCK_REPORTS'}
   },
   {
      path: '/relatorios/pdv/fechamentos',
      name: 'RelatoriosPdvFechamentos',
      component: () => import('../views/relatorios/pdv/Fechamentos.vue'),
      meta: { 'icon': 'bx bx-history' , role: 'FINANCIAL_REPORTS'}
   },
   {
      path: '/relatorios/pdv/vendas',
      name: 'RelatoriosPdvVendas',
      component: () => import('../views/relatorios/pdv/Vendas.vue'),
      meta: { 'icon': 'bx bx-chart' , role: 'SALES_REPORTS'}
   },
   {
      path: '/relatorios/pdv/ticket-medio',
      name: 'RelatoriosPdvTicketMedio',
      component: () => import('../views/relatorios/pdv/TicketMedio.vue'),
      meta: { 'icon': 'bx bx-bar-chart-alt-2' , role: 'SALES_REPORTS'}
   },
   {
      path: '/configuracoes',
      name: 'Configuracoes',
      redirect: '/configuracoes/fiscal',
      meta: { 'icon': 'bx bx-receipt', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/geral',
      name: 'ConfiguracoesGeral',
      redirect: '/configuracoes/fiscal',
      meta: { 'icon': 'bx bx-receipt', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/fiscal',
      name: 'ConfiguracoesFiscal',
      component: () => import('../views/financeiro/configuracoes/Fiscal.vue'),
      meta: { 'icon': 'bx bx-receipt', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/operacoes',
      name: 'ConfiguracoesOperacoes',
      component: () => import('../views/financeiro/configuracoes/Operacoes.vue'),
      meta: { 'icon': 'bx bx-list-ul', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/tributacao',
      name: 'ConfiguracoesTributacao',
      redirect: '/produtos/tributacao',
      meta: { 'icon': 'bx bx-percent', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/pdv',
      name: 'ConfiguracoesPdv',
      component: () => import('../views/financeiro/configuracoes/ParametrosRotina.vue'),
      props: { rotina: 'pdv' },
      meta: { 'icon': 'bx bx-store', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/comercial',
      name: 'ConfiguracoesComercial',
      component: () => import('../views/financeiro/configuracoes/ParametrosRotina.vue'),
      props: { rotina: 'comercial' },
      meta: { 'icon': 'bx bx-cart', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/produtos-servicos',
      name: 'ConfiguracoesProdutosServicos',
      component: () => import('../views/financeiro/configuracoes/ParametrosRotina.vue'),
      props: { rotina: 'produtos-servicos' },
      meta: { 'icon': 'bx bx-package', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/pessoas',
      name: 'ConfiguracoesPessoas',
      component: () => import('../views/financeiro/configuracoes/ParametrosRotina.vue'),
      props: { rotina: 'pessoas' },
      meta: { 'icon': 'bx bx-id-card', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/financeiro',
      name: 'ConfiguracoesFinanceiro',
      component: () => import('../views/financeiro/configuracoes/ParametrosRotina.vue'),
      props: { rotina: 'financeiro' },
      meta: { 'icon': 'bx bx-wallet', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/estoque',
      name: 'ConfiguracoesEstoque',
      component: () => import('../views/financeiro/configuracoes/ParametrosRotina.vue'),
      props: { rotina: 'estoque' },
      meta: { 'icon': 'bx bx-box', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/configuracoes/whatsapp',
      name: 'ConfiguracoesWhatsApp',
      component: () => import('../views/financeiro/configuracoes/WhatsAppConfig.vue'),
      meta: { 'icon': 'bxl-whatsapp', role: 'CONFIGURACAO_VIEW' }
   },
   {
      path: '/changelog',
      name: 'Changelog',
      component: () => import('../views/changelog/Changelog.vue'),
      meta: {'icon': 'bx bx-history', role: 'CONFIGURACAO_VIEW'}
   },
   {
      path: '/assinatura',
      name: 'MinhaAssinatura',
      component: () => import('../views/assinatura/MinhaAssinatura.vue'),
      meta: { requireAuth: true, pageTitle: 'Minha Assinatura', role: 'COMPANY_CONFIG' }
   },
   {
      path: '/sistema/reportar-suporte',
      name: 'ReportForm',
      component: () => import('../views/sistema/support/ReportForm.vue'),
      meta: { requireAuth: true, pageTitle: 'Suporte / Report' }
   },
   {
      path: '/sistema/suporte/tickets',
      name: 'TicketList',
      component: () => import('../views/sistema/support/TicketList.vue'),
      meta: { requireAuth: true, pageTitle: 'Meus Tickets' }
   },
   {
      path: '/pdvs-offline/gerenciamento',
      name: 'PdvOfflineGerenciamento',
      component: () => import('../views/pdvs-offline/Gerenciamento.vue'),
      meta: { 'icon': 'bx bx-devices' , role: 'PDVOFFLINE_VIEW'}
   },
   {
      path: '/pdvs-offline/monitoramento',
      name: 'PdvOfflineMonitoramento',
      component: () => import('../views/pdvs-offline/Monitoramento.vue'),
      meta: { 'icon': 'bx bx-desktop' , role: 'PDVOFFLINE_VIEW'}
   },
   {
      path: '/pdvs-offline/cargas',
      name: 'PdvOfflineCargas',
      component: () => import('../views/pdvs-offline/GerenciamentoCargas.vue'),
      meta: { 'icon': 'bx bx-sync' , role: 'PDVOFFLINE_VIEW'}
   },
   {
      path: '/pdvs-offline/atualizacoes',
      name: 'PdvOfflineAtualizacoes',
      component: () => import('../views/pdvs-offline/AtualizacoesPdv.vue'),
      meta: { 'icon': 'bx bx-download' , role: 'PDVOFFLINE_VIEW'}
   },
   {
      path: '/pdvs-offline/personalizacao',
      name: 'PdvOfflinePersonalizacao',
      component: () => import('../views/pdvs-offline/Personalizacao.vue'),
      meta: { 'icon': 'bx bx-palette' , role: 'PDVOFFLINE_EDIT'}
   }
]

const router = new VueRouter({
   mode: 'abstract',
   base: process.env.BASE_URL,
   routes
})

// Guard de navegação
router.beforeEach((to, from, next) => {
   if (to.meta && to.meta.public) {
      next()
      return
   }
   if (to.path && to.path.startsWith('/portal/')) {
      next()
      return
   }

   const isLogado = store.state.isLogado
   const empresa = store.state.empresa
   const rotasPublicas = ['/selecaoEmpresa', '/gerencial', '/portal/orcamento', '/portal/pedido-compra']
   const rotasProtegidas = ['/paginaInicial', '/conversas', '/tutoriais', '/perfil', '/representantes', '/planos', '/empresas', '/assinaturas']

   // Se não está logado e tenta acessar rota protegida
   if (!isLogado && (rotasProtegidas.some(r => to.path.startsWith(r)) || rotasPublicas.some(r => to.path.startsWith(r)))) {
      // Não redireciona, deixa o App.vue mostrar o Login
      next()
      return
   }

   // Se está logado mas não tem empresa selecionada
   if (isLogado && !empresa) {
      // Se tenta acessar rota protegida (exceto seleção de empresa e gerencial)
      if (rotasProtegidas.some(r => to.path.startsWith(r))) {
         next('/selecaoEmpresa')
         return
      }
      // Permite acesso a seleção de empresa e gerencial
      if (rotasPublicas.some(r => to.path.startsWith(r))) {
         next()
         return
      }
   }

   // Se está logado e tem empresa, permite acesso a todas as rotas
   if (isLogado && empresa) {
      if (to.meta && to.meta.role) {
         const user = store.state.dadosUsuario
         const roles = user && user.roles ? user.roles : []
         const modules = user && user.modules ? user.modules : []
         
         const planRoles = (empresa && Array.isArray(empresa.planRoles) && empresa.planRoles.length > 0)
            ? empresa.planRoles
            : null

         const requiredRoles = [].concat(to.meta.role)

         if (planRoles && !requiredRoles.some(role => planRoles.includes(role))) {
            Vue.prototype.$toast.fire({ icon: 'warning', title: 'Este recurso não faz parte do plano contratado da empresa.' })
            next(false)
            return
         }

         let hasRole = requiredRoles.some(role => roles.includes(role))
         if (!hasRole && modules.includes('COMPANY_ADMIN')) {
            hasRole = true
         }
         
         if (!hasRole) {
            Vue.prototype.$toast.fire({ icon: 'warning', title: 'Você não tem permissão para acessar esta tela.' })
            next(false)
            return
         }
      }
      next()
      return
   }

   next()
})

/* eslint-disable-next-line no-unused-vars */
router.beforeResolve((to, from, next) => {
   $("#app > .wrapper").removeClass("toggled");
   $("#main-content").animate({ scrollTop: 0 }, 0);
   next()
})

router.afterEach((to) => {
   saveLastAppRoute(to)
   if (to.path === '/pdv') {
      sessionStorage.setItem('last_pdv_route', '/pdv')
   } else {
      sessionStorage.removeItem('last_pdv_route')
   }
})

export default router

